type SchemaFieldNode = {
    name?: string;
    hidden?: boolean;
    children?: SchemaFieldNode[];
};

export const collectFormFieldNamesFromSchema = (schema: SchemaFieldNode[]): string[] => {
    const names = new Set<string>();
    for (const item of schema) {
        if (item.hidden) {
            continue;
        }
        if (item.children?.length) {
            for (const child of item.children) {
                if (child.hidden || !child.name) {
                    continue;
                }
                names.add(child.name);
            }
            continue;
        }
        if (item.name) {
            names.add(item.name);
        }
    }
    return Array.from(names);
};
